import _defineProperty from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import React from "react";
var __jsx = React.createElement;
import { faXmark } from "@fortawesome/pro-regular-svg-icons";
import { Dialog, Transition } from "@headlessui/react";
import classNames from "classnames";
import { Fragment } from "react";
import AwesomeIcon from "../AwesomeIcon";
var Modal = function Modal(props) {
  var children = props.children,
    show = props.show,
    onClose = props.onClose,
    className = props.className,
    title = props.title,
    closeOnClickAway = props.closeOnClickAway,
    closeButton = props.closeButton,
    isAlert = props.isAlert,
    isLoading = props.isLoading,
    bgOpacity = props.bgOpacity,
    _props$titleClassName = props.titleClassName,
    titleClassName = _props$titleClassName === void 0 ? "" : _props$titleClassName;
  return /*#__PURE__*/React.createElement(Transition.Root, {
    show: show,
    as: Fragment
  }, /*#__PURE__*/React.createElement(Dialog, {
    as: "div",
    className: "relative z-50",
    onClose: !!onClose && closeOnClickAway ? onClose : function () {}
  }, /*#__PURE__*/React.createElement(Transition.Child, {
    as: Fragment,
    enter: "ease-out duration-300",
    enterFrom: "opacity-0",
    enterTo: "opacity-100",
    leave: "ease-in duration-200",
    leaveFrom: "opacity-100",
    leaveTo: "opacity-0"
  }, /*#__PURE__*/React.createElement("div", {
    className: classNames("fixed inset-0 bg-black bg-opacity-80 transition-opacity", {
      "!bg-black !bg-opacity-50 sm:!bg-zinc-900 sm:!bg-opacity-50": bgOpacity
    })
  })), /*#__PURE__*/React.createElement("div", {
    className: "fixed flex flex-col h-full inset-0 z-10"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex sm:min-h-full h-full items-end justify-center text-center sm:items-center sm:p-0"
  }, /*#__PURE__*/React.createElement(Transition.Child, {
    as: Fragment,
    enter: "ease-out duration-300",
    enterFrom: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
    enterTo: "opacity-100 translate-y-0 sm:scale-100",
    leave: "ease-in duration-200",
    leaveFrom: "opacity-100 translate-y-0 sm:scale-100",
    leaveTo: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
  }, /*#__PURE__*/React.createElement(Dialog.Panel, {
    className: classNames("relative transform shadow-xl transition-all w-full rounded-lg bg-gray-200 dark:bg-gray-800 border border-gray-300 dark:border-gray-700 text-gray-800 dark:text-white", _defineProperty({}, className, !!className))
  }, !!title && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: classNames("flex items-center justify-between p-4 border-b border-gray-300 dark:border-gray-600 rounded-t", {
      "bg-gray-300 dark:bg-gray-700": isAlert
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: classNames("text-xl sm:text-lg", _defineProperty({}, titleClassName, !!titleClassName))
  }, !!title && title), !!onClose || !!closeButton ? !!closeButton ? closeButton : /*#__PURE__*/React.createElement("div", {
    onClick: onClose
  }, /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: faXmark,
    size: "xl",
    className: "block text-black dark:text-white cursor-pointer w-6"
  })) : null)), children, isLoading && /*#__PURE__*/React.createElement("div", {
    className: "absolute flex flex-col h-full w-full items-center justify-center overflow-hidden bg-black opacity-30"
  }, /*#__PURE__*/React.createElement("div", {
    className: "border-solid border-white border-2 border-r-transparent animate-spin inline-block w-8 h-8 rounded-full text-blue-600 mr-3",
    role: "status"
  }))))))));
};
export default Modal;